export default __webpack_public_path__ + "static/media/pcard8.07292658.png";